import { Component, OnInit, ViewContainerRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalPopupService } from 'app/helpers/global-popup.service';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'global-popup-container',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './global-popup-container.component.html',
  styleUrls: ['./global-popup-container.component.scss'],
  animations: [
    trigger('backdropAnimation', [
      state('hidden', style({ opacity: 0 })),
      state('visible', style({ opacity: 1 })),
      transition('hidden <=> visible', animate('200ms ease-in-out'))
    ]),
    trigger('popupAnimation', [
      state('hidden', style({ opacity: 0, transform: 'scale(0.9)' })),
      state('visible', style({ opacity: 1, transform: 'scale(1)' })),
      transition('hidden <=> visible', animate('300ms ease-out'))
    ])
  ]
})
export class GlobalPopupContainerComponent implements OnInit {
  isOpen = false;
  currentPopup: any = null;

  @ViewChild('popupHost', { read: ViewContainerRef }) popupHost!: ViewContainerRef;

  constructor(private popupService: GlobalPopupService) {}

  ngOnInit(): void {
    this.popupService.popup$.subscribe((popupData) => {
      if (popupData) {
        this.currentPopup = popupData;
        this.isOpen = true;
        this.renderComponent(popupData);
      } else {
        this.isOpen = false;
        setTimeout(() => {
          this.clearComponent();
        }, 300);
      }
    });
  }

  private renderComponent(config: any): void {
    if (!this.popupHost) {
      setTimeout(() => this.renderComponent(config), 100);
      return;
    }

    this.popupHost.clear();
    const componentRef = this.popupHost.createComponent(config.component);
    if (config.data) {
      Object.keys(config.data).forEach((key) => {
        const instance = componentRef.instance as any;
        const value = config.data[key];
        if (typeof value === 'function' && instance[key]?.subscribe) {
          instance[key].subscribe(value);
        } else {
          instance[key] = value;
        }
      });
    }

    if ((componentRef.instance as any).closeModal) {
      (componentRef.instance as any).closeModal.subscribe(() => {
        this.popupService.closePopup();
      });
    }
  }

  private clearComponent(): void {
    if (this.popupHost) {
      this.popupHost.clear();
    }
  }

  closePopup(): void {
    this.popupService.closePopup();
  }
}